
import './TargetDateRenderer.css';

export interface DateTimeCellRendererProps {
    targetDate: string,
    startTime: string | '',
    endTime: string | '',
}

const TargetDateRenderer = (dateToRender: DateTimeCellRendererProps) => {

    return (
      <div style={{ textAlign: 'center' }}>
        {dateToRender.targetDate}

        {dateToRender.startTime && dateToRender.endTime && (
          <div className='target-time'>
            {dateToRender.startTime} à {dateToRender.endTime}
          </div> 
        )
        }
      </div>
    );

  };

  export default TargetDateRenderer;
